<div class="audio-recorder">
  @if (!processing$()) {
    <div class="audio-recorder__audio" [ngClass]="{ 'audio-recorder__background': paused$() || stopped$() }">
      @if (paused$() || stopped$()) {
        <div class="audio-recorder__audio-player">
          <button class="audio-recorder__audio-player-button" (click)="playPauseRecordedAudio()">
            <fa-icon [icon]="pausedPlayback$() ? faPlay : faPause" class="tertiary"></fa-icon>
          </button>
        </div>
      } @else {
        <div class="audio-recorder__audio-player">
          <fa-icon [icon]="faMicrophone" class="warn"></fa-icon>
        </div>
      }
      <div [class.hidden]="!paused$() && !stopped$()" class="audio-recorder__audio-wave">
        <div id="record"></div>
      </div>

      <div [class.hidden]="paused$() || stopped$()" class="audio-recorder__audio-wave">
        <div id="recorder"></div>
      </div>

      <div class="audio-recorder__audio-progress">
        <span class="audio-recorder__audio-progress-time"> {{ progressTime$() }} </span>
      </div>
    </div>
    <div class="audio-recorder__actions">
      <div class="audio-recorder__actions-buttons">
        <button class="audio-recorder__actions-buttons__delete" (click)="abortRecording()">
          <fa-icon [icon]="faTrashCan" class="tertiary"></fa-icon>
        </button>

        @if (!stopped$() && !paused$()) {
          <button class="audio-recorder__actions-buttons__stop" (click)="pauseRecording()">
            <fa-icon [icon]="faCircleStop" class="warn"></fa-icon>
          </button>
        } @else if (!stopped$() && paused$()) {
          <button class="audio-recorder__actions-buttons__record" (click)="resumeRecording()">
            <fa-icon [icon]="faMicrophone" class="warn"></fa-icon>
          </button>
        }

        <button class="audio-recorder__actions-buttons__send" (click)="sendAudioMessage()">
          <fa-icon [icon]="faPaperPlaneTop" class="secondary"></fa-icon>
        </button>
      </div>
    </div>
  }
</div>